module.exports = __webpack_public_path__ + "img/dzpdf1.8d2366e9.png";